import { InjectionToken, Inject, Injectable, NgZone } from '@angular/core';

import { isEmpty } from 'lodash';

import { environment } from '~environment';

export const GOOGLE_ANALYTICS_ACCOUNT_KEY = new InjectionToken<string>('google-analytics');

const NOOP = (...args: any[]) => { };

export abstract class AnalyticsService {
  abstract initialize();
  abstract logPageview(url: string);
  abstract emitEvent(action: string, eventData?: Partial<AnalyticsEvents>);
}

export class NoopAnalyticsService extends AnalyticsService {
  initialize() { }
  logPageview() { }
  emitEvent() { }
}

export interface AnalyticsEvents {
  event_category: string;
  event_label: string;
  value: number;
}

@Injectable()
export class GoogleAnalyticsService extends AnalyticsService {
  GOOGLE_ANALYTICS_OBJECT_NAME = 'gtag';

  constructor(
    @Inject(GOOGLE_ANALYTICS_ACCOUNT_KEY) private accountKey: string,
    private ngZone: NgZone
  ) {
    super();
  }

  private get analytics(): Function {
    return window[this.GOOGLE_ANALYTICS_OBJECT_NAME] || NOOP;
  }

  initialize() {
    if (!this.accountKey) {
      return;
    }

    const head = document.querySelector('head');
    const googleAnalyticsFirstScript = document.createElement('script');
    googleAnalyticsFirstScript.async = true;
    googleAnalyticsFirstScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + environment.analyticsId;

    const googleAnalyticsSecondScript = document.createElement('script');
    googleAnalyticsSecondScript.innerHTML = `window.dataLayer = window.dataLayer || [];\n` +
      `function gtag(){dataLayer.push(arguments);}\n` +
      `gtag(\'js\', new Date())`;
    head.insertBefore(googleAnalyticsSecondScript, head.firstChild);
    head.insertBefore(googleAnalyticsFirstScript, head.firstChild);
  }

  logPageview(url: string) {
    this.ngZone.run(() => this.analytics('config', this.accountKey, { 'page_path': url }));
  }

  emitEvent(action: string, eventData?: Partial<AnalyticsEvents>) {
    if (!isEmpty(eventData)) {
      this.ngZone.run(() => this.analytics('event', action, eventData));
    } else {
      this.ngZone.run(() => this.analytics('event', action));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/core/services/analytics.service.ts